import { Control, FieldValues, Path, useController } from "react-hook-form";

import { TextInput, TextInputProps } from "#shared/view/designSystem/inputs/TextInput";

interface Props<T extends FieldValues> extends TextInputProps {
  label?: string;
  required?: boolean;
  html5Validation?: boolean;
  step?: string;
  rules?: Record<string, unknown>;
  rows?: number;
  control: Control<T>;
  name: Path<T>;
  onValueChange?: (value: string) => void;
}

export const TextInputController = <T extends FieldValues>({
  name,
  label,
  control,
  required,
  html5Validation = true,
  rules,
  onValueChange,
  ...props
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules: { required, ...rules } });
  return (
    <TextInput
      {...field}
      label={label}
      // oxlint-disable-next-line typescript/no-base-to-string
      error={error?.message?.toString() || !!error?.type}
      required={html5Validation ? required : false}
      {...props}
      value={field.value ? field.value.toString() : ""}
      onChange={(event) => {
        field.onChange(event);
        onValueChange?.(event.target.value);
      }}
    />
  );
};
